import script from "./DepartureDestination.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartureDestination.vue?vue&type=script&setup=true&lang=js"

import "./DepartureDestination.vue?vue&type=style&index=0&id=17fa9596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17fa9596"]])

export default __exports__